import React from 'react';
import { Star, MapPin, ShieldCheck } from 'lucide-react';
import { trustBar } from '../data/mock';

const iconMap = {
  'star': Star,
  'map-pin': MapPin,
  'shield-check': ShieldCheck
};

export const TrustBar = () => {
  return (
    <section className="py-12 bg-white border-b border-gray-100">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16">
          {trustBar.stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <div key={index} className="flex items-center gap-3">
                <Icon className="h-6 w-6 text-teal-600" />
                <span className="text-gray-700 font-medium text-lg">{stat.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
